import { useCallback, useEffect, useState } from "react";
import type { AuthenticationSessionResponse } from "../../redux/types/Authentication";
import { getApiPath } from "./ApiUtils";
import { apiCall } from "./StandaloneServerDataUtils";

export type StandaloneAuthenticationSessionState =
    | { status: "checking"; retry: () => void }
    | {
          status: "ready";
          session: AuthenticationSessionResponse;
          retry: () => void;
      }
    | { status: "error"; error: string; retry: () => void };

type InternalState =
    | { status: "checking" }
    | { status: "ready"; session: AuthenticationSessionResponse }
    | { status: "error"; error: string };

export const useStandaloneAuthenticationSession =
    (): StandaloneAuthenticationSessionState => {
        const [version, setVersion] = useState(0);
        const [state, setState] = useState<InternalState>({
            status: "checking",
        });
        const retry = useCallback(
            () => setVersion((current) => current + 1),
            []
        );

        useEffect(() => {
            setState({ status: "checking" });
            apiCall(
                getApiPath("auth/session"),
                undefined,
                {
                    success: (response: AuthenticationSessionResponse) =>
                        setState({ status: "ready", session: response }),
                    error: (error: string) =>
                        setState({ status: "error", error }),
                    exception: (error: Error) =>
                        setState({ status: "error", error: error.message }),
                },
                { method: "GET" }
            );
        }, [version]);

        return { ...state, retry } as StandaloneAuthenticationSessionState;
    };
